import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.25 15.713c-1.513-.188-2.766-.847-3.76-1.979C3.498 12.604 3 11.275 3 9.75c0-.825.163-1.616.487-2.372A5.848 5.848 0 0 1 4.875 5.4l1.069 1.069A4.226 4.226 0 0 0 4.866 7.95a4.478 4.478 0 0 0-.366 1.8c0 1.1.35 2.072 1.05 2.916.7.843 1.6 1.359 2.7 1.546v1.5Zm1.5 0v-1.5a4.475 4.475 0 0 0 2.69-1.557A4.374 4.374 0 0 0 13.5 9.75c0-1.25-.438-2.313-1.313-3.188C11.313 5.688 10.25 5.25 9 5.25h-.056l.825.825-1.05 1.05L6.094 4.5l2.625-2.625 1.05 1.05-.825.825H9c1.675 0 3.094.581 4.256 1.744C14.42 6.656 15 8.075 15 9.75c0 1.512-.497 2.834-1.49 3.966-.994 1.13-2.248 1.796-3.76 1.997Z"
    }, null, -1)
  ])))
}
export default { render: render }